module.exports = {"data":{"site":{"siteMetadata":{"title":"File For EIN"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 716
// module chunks = 142629428675168